import { t } from '@lingui/core/macro'
import { defineEntityConfig } from '@pkg/db/schema/EntityConfig'
import { formatAddress } from '@pkg/shared/utils'
import { FaHandshake } from 'react-icons/fa6'
import { CooperationPartnerSchema } from './schema/CooperationPartner'

export const CooperationPartnerConfig = defineEntityConfig(() => ({
  schema: CooperationPartnerSchema,

  label: t`Kooperationspartner`,
  labelPlural: t`Kooperationspartner`,

  icon: FaHandshake,

  relationSelectionColumns: [
    {
      title: t`Name`,
      key: 'name',
      render: (_, record) => (
        <div>
          <div>{record.name}</div>
          <div className="text-xs text-gray-500">{formatAddress([], record.address)}</div>
        </div>
      ),
    },
    {
      title: t`Gruppe`,
      key: 'groupName',
      render: (_, record) => record.groupName,
    },
  ],

  search: {
    sortableFields: ['name', 'groupName', 'createdAt'] as const,
    defaultSortBy: 'name',
    defaultSortOrder: 'asc',
  },

  format: {
    primary: val => val?.name,
  },
}))
